import * as angular from 'angular';
import { countries } from '../../../../../../src/pages/settings/registration/components/countries';

class ShipperPremiumServicesDebtorDetailsComponentCtrl
    implements ng.IController
{
    rememberedDebtor: ShipperPremiumServiceBillingAddressCreationDto;
    debtor: ShipperPremiumServiceBillingAddressCreationDto;
    countries: typeof countries;
    onSubmit;
    editingDebtor: boolean;

    constructor() {
        this.countries = countries;
    }

    $onInit() {}

    localizeDebtorCountry() {
        return !this.debtor || !this.debtor.country
            ? null
            : this.countries.find((value) => value.value == this.debtor.country)
                  .label;
    }

    rememberDebtor() {
        this.rememberedDebtor = angular.copy(this.debtor);
    }

    submitDebtor() {
        this.onSubmit(this.debtor);
        this.editingDebtor = false;
    }
}

angular.module('app').component('pkpShipperPremiumServicesDebtorDetails', {
    controller: ShipperPremiumServicesDebtorDetailsComponentCtrl,
    template:
        require('app/shipper-premium-services-wizard/shipper-premium-services-debtor-details.component.html'),
    bindings: {
        debtor: '=',
        shipperVat: '<',
        shipperName: '<',
        editingDebtor: '=',
        onSubmit: '&'
    }
});
